import { render } from "./EventModalLowerInfoBox.vue?vue&type=template&id=6673e93c&scoped=true"
import script from "./EventModalLowerInfoBox.vue?vue&type=script&lang=js"
export * from "./EventModalLowerInfoBox.vue?vue&type=script&lang=js"

import "./EventModalLowerInfoBox.vue?vue&type=style&index=0&id=6673e93c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6673e93c"

export default script